module.exports = __webpack_public_path__ + "img/icon_star01.4242f2e3.png";